// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../types';

import gql from 'graphql-tag';
export type UseDateTimeDurationEventFragment = { __typename?: 'Event', fromDateTime: string, toDateTime: string };

export type UseDateTimeDurationProposalFragment = { __typename?: 'Proposal', fromDateTime: string, toDateTime: string };

export const UseDateTimeDurationEventFragmentDoc = gql`
    fragment UseDateTimeDurationEvent on Event {
  fromDateTime
  toDateTime
}
    `;
export const UseDateTimeDurationProposalFragmentDoc = gql`
    fragment UseDateTimeDurationProposal on Proposal {
  fromDateTime
  toDateTime
}
    `;